import { useQuery } from '@tanstack/react-query';
import { getGuidelinesByFolder } from '../api/guidelines.api';

type UseGuidelinesByFolderOptions = {
  suppressErrorNotification?: boolean;
};

/**
 * Hook to fetch guidelines for a specific folder
 *
 * @param folderId - The folder ID to fetch guidelines for
 * @param options - Optional per-request tuning (e.g. toast suppression)
 * @returns TanStack Query result with guidelines data
 */
export const useGuidelinesByFolder = (
  folderId: string | undefined,
  options?: UseGuidelinesByFolderOptions,
) => {
  return useQuery({
    // `options` only tunes toast suppression on the request — the fetched data
    // is identical, so it must NOT split the cache bucket.
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['guidelines', 'folder', folderId],
    queryFn: () => {
      if (!folderId) return [];
      return getGuidelinesByFolder(folderId, options);
    },
    enabled: !!folderId,
    staleTime: 2 * 60 * 1000, // 2 minutes
    refetchOnWindowFocus: false,
  });
};
